import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Switch } from 'antd';
import { setModalState } from '../../../../reducers/Modal/actions';
import { MODAL_EDIT_FIELD } from '../../../../reducers/Modal/types';
import { ZorbaButton } from '../../../../components/forms';
import {
  BUTTON_VARIANT_DARK,
  BUTTON_VARIANT_LINK,
} from '../../../../components/forms/ZorbaButton/constants';
import { EditFieldModal } from '../EditFieldModal';
import { getBuyboxFieldsToEdit } from './constants';
import { updateBuyerDetails } from '../../../../reducers/Buyer/actions';

export const BuyboxRules = () => {
  const dispatch = useDispatch();
  const { organization } = useSelector(({ AuthReducer }) => AuthReducer);
  const { isLoading } = useSelector(({ BuyerReducer }) => BuyerReducer);
  const [selectedField, setSelectedField] = useState();
  const [fieldValue, setFieldValue] = useState();

  const fields = getBuyboxFieldsToEdit({
    isBuyingWithFoundationIssues:
      organization.buyerConfig.isBuyingWithFoundationIssues,
    requireDoubleClose: organization.buyerConfig.requireDoubleClose,
  });

  const handleModalClose = () => {
    setSelectedField();
    dispatch(setModalState(MODAL_EDIT_FIELD, false));
  };

  useEffect(() => {
    if (selectedField) {
      setFieldValue(selectedField.value);
    }
  }, [selectedField]);

  const handleOpenModal = (field) => {
    setSelectedField(field);
    dispatch(setModalState(MODAL_EDIT_FIELD, true));
  };

  const handleSwitchChange = (value) => {
    setFieldValue(value);
    dispatch(
      updateBuyerDetails(
        {
          buyerConfig: {
            ...organization.buyerConfig,
            [selectedField.fieldName]: value,
          },
        },
        'Updating settings succeeded!',
        'Updating settings failed. Please try again!',
        () => dispatch(setModalState(MODAL_EDIT_FIELD, false)),
      ),
    );
  };

  return (
    <>
      {fields.map((field) => (
        <>
          <div key={field.fieldName} className="field-container">
            <div className="description-container">
              <span className="label">{field.label}</span>
              <span className="sub-title">{field.subTitle}</span>
              <span className="value">{field.valueDescription}</span>
            </div>
            <div>
              <ZorbaButton
                variant={BUTTON_VARIANT_LINK}
                fullWidth={false}
                className="button"
                onClick={() => handleOpenModal(field)}
              >
                Edit
              </ZorbaButton>
            </div>
          </div>
          <Divider className="divider" />
          <EditFieldModal selectedField={selectedField}>
            <span className="sub-title">{selectedField?.subTitle}</span>
            <div className="switch-container">
              <Switch
                checked={fieldValue}
                onChange={(checked) => handleSwitchChange(checked)}
              />
            </div>
            <div className="notification-button-container">
              <ZorbaButton
                fullWidth={false}
                variant={BUTTON_VARIANT_DARK}
                onClick={handleModalClose}
                disabled={isLoading}
                loading={isLoading}
              >
                Close
              </ZorbaButton>
            </div>
          </EditFieldModal>
        </>
      ))}
    </>
  );
};
